import { api } from '../../lib/api';
import type { FeaturedResponse } from '@pms/shared';

/**
 * GET /v1/public/featured — the curated homepage feed (TASK-61): the ordered
 * featured set + the single Editor's Pick. Approved + active + not-hidden only;
 * enforcement lives server-side at read time.
 */
export async function getFeatured(): Promise<FeaturedResponse> {
  const { data } = await api.get<FeaturedResponse>('/featured');
  return data;
}
